import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import keyFeaturesStyles from './keyFeaturesStyles';
import { IKeyFeature } from '../../../../../../../gqlCommon/model/IVariants';
import Translation from '../../../../../../../gqlCommon/components/translation/Translation';
import SpecificationDisclaimer from '../../../../../../../common/components/presentation/SpecificationDisclaimer';

export interface IKeyFeaturesProps {
  keyFeatures: IKeyFeature[];
}

const KeyFeatures: FunctionComponent<IKeyFeaturesProps> = ({ keyFeatures }) => {
  const styles = keyFeaturesStyles();

  if (!keyFeatures?.length) {
    return null;
  }

  return (
    <Box className={styles.container} data-test="customise:featuresContent">
      <Typography variant="body1" className={styles.title} data-test="customise:featuresTitle">
        <Translation id="trans__configurator__customise_page_variant_section__features_subtitle" />
      </Typography>
      {keyFeatures.map((feature: IKeyFeature, index: number) => (
        <Typography
          component="p"
          variant="caption"
          className={styles.description}
          key={index}
          data-test="customise:featuresItem"
        >
          {feature.description}
          {feature.disclaimer && <SpecificationDisclaimer disclaimer={feature.disclaimer} />}
        </Typography>
      ))}
    </Box>
  );
};

export default KeyFeatures;
